import { ResponsiveTable } from '@/components/Table/ResponsiveTable/ResponsiveTable';
import { StyledCard } from '@/components/VehicleSection/VehicleSection';
import { EmptyVehicleSectionDisclaimer } from '@/reports/shared/ReportSection/EmptyVehicleSectionDisclaimer/EmptyVehicleSectionDisclaimer';
import { ReportSection } from '@/reports/shared/ReportSection/ReportSection';
import { HowItWorksCTA } from '@/reports/shared/ReportSection/components';
import { AutomobileLiens } from '@/reports/types/vehicles';
import { Text } from '@/theme/index';
import { formatDateFromReport } from '@/utils/formatDateFromReport/formatDateFromReport';

export interface VehicleLiensProps {
  /** A list of all sales data */
  vehicleLiensList: AutomobileLiens;
}

function HowItWorksCTAContent() {
  return (
    <Text
      variant="body2"
      fontSize="0.9rem"
      color={(theme) => theme.palette.grey[800]}
    >
      Lien data may include the name of the financial institution that has a
      lien on the vehicle and the date the lien was issued. Our Lien Data Source
      covers a majority of the market in the US and Canada. Lien data is sourced
      in different timeframes based on the lender. Some are updated daily,
      whereas others may be weekly, semi-weekly, monthly and semi-monthly.
    </Text>
  );
}

/** It renders a table view of sales listings */
export const VehicleLiens: React.FC<VehicleLiensProps> = ({
  vehicleLiensList,
}) => {
  const reserializedInstalledOptionsData = vehicleLiensList?.map((lien) => {
    return [
      <Text variant="body2" sx={{ p: 1 }}>
        {formatDateFromReport(lien?.date?.full, 'MM/dd/yy')}
      </Text>,
      <Text variant="body2" sx={{ p: 1 }}>
        {lien?.lienholder || '-'}
      </Text>,
    ];
  });

  const header = [
    <Text variant="h5" sx={{ p: 1, m: 0 }}>
      Lien issue date
    </Text>,
    <Text variant="h5" sx={{ p: 1, m: 0 }}>
      Issuing authority
    </Text>,
  ];
  return (
    <ReportSection
      showTopBar
      title="Possible Lien records"
      hasContent={vehicleLiensList?.length > 0}
      sectionId="vehicle-liens"
      data-cy="vehicle-liens-report-section"
      howItWorks={<HowItWorksCTA content={HowItWorksCTAContent()} />}
      customEmptyText={<EmptyVehicleSectionDisclaimer title="possible lien" />}
    >
      <StyledCard variant="outlined">
        <ResponsiveTable
          tableData={reserializedInstalledOptionsData}
          headers={header}
          sectionId="vehicle-liens-data"
        />
      </StyledCard>
    </ReportSection>
  );
};
